import { MAX_IMPORT_FILE_SIZE_BYTES } from '@klareospace/pharos-lib-types';

// ─── Constants ──────────────────────────────────────────────────────────────

const BYTES_PER_MB = 1024 * 1024;

/**
 * `MAX_IMPORT_FILE_SIZE_BYTES` rendered as MB for display copy (dropzone helper text, validation
 * errors, and the server-rejection message). Bytes are the domain fact (shared in
 * `pharos-lib-types`); this MB rendering is presentation-only and stays local to this feature.
 */
export const MAX_IMPORT_FILE_SIZE_MB = MAX_IMPORT_FILE_SIZE_BYTES / BYTES_PER_MB;
